import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { TextField } from '@mui/material';
import ZipCodeInput from 'common-mui/components/ZipCodeInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputAddressZipCode = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="zipCode"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        // Pattern matching handles format
        // so we only need to check length.
        validate: (v) => v?.trim().length === 5 || 'Please enter a 5-digit ZIP code.',
      }}
    >
      <TextField
        fullWidth
        label="Zip Code"
        InputProps={{ inputComponent: ZipCodeInput }}
      />
    </ValidatedTextField>
  );
};

export default InputAddressZipCode;
